// extracted by mini-css-extract-plugin
module.exports = {"container":"HeadingAssessment_container__2yw01","hideContainer":"HeadingAssessment_hideContainer__2cL0Q"};